import React, { useMemo } from 'react';
import {
  RecordContextProvider,
  useGetManyAggregate,
  useRecordContext,
} from 'react-admin';

import { Box, Typography } from '@mui/material';

import ReferenceEntityField from '../../../customFields/ReferenceEntityField';
import EntityDisplayNameField from '../../../customFields/EntityDisplayNameField';
import getCaseProcessors, { getProcessorKey } from '../../../utilities/caseProcessors';
import { IRequest } from '../../request/types';
import { ICase } from '../../../utilities/schemas/case';

const emptyRequests: string[] = [];

// Rendered per row, only while the column is visible. useGetManyAggregate merges the
// requests of all visible rows into a single getMany call.
const CaseProcessors = () => {
  const record = useRecordContext<ICase>();
  const requestIds = record?.requests ?? emptyRequests;

  const { data, isPending } = useGetManyAggregate<IRequest>(
    'requests',
    { ids: requestIds },
    { enabled: requestIds.length > 0 },
  );

  const processors = useMemo(() => getCaseProcessors(data ?? []), [data]);

  if (requestIds.length > 0 && isPending) return null;
  if (processors.length === 0) return <Typography>-</Typography>;

  return (
    <Box display="flex" flexWrap="wrap" gap={1}>
      {processors.map((processor) => (
        <RecordContextProvider key={getProcessorKey(processor)} value={processor}>
          <ReferenceEntityField source="">
            <EntityDisplayNameField chip />
          </ReferenceEntityField>
        </RecordContextProvider>
      ))}
    </Box>
  );
};

export default CaseProcessors;
